import React from 'react';
import { useSelector } from 'react-redux';
import { getDatasourceTables } from '@/store-selectors';
import { EmptyDatabaseMessage } from '@/views/QueryBuilder/subcomponents/EmptyDatabaseMessage';
import styles from '@/css/module/new-world.css';
import { useAppSelector } from '@/store/hooks';
import { selectGetStarted } from '@/features/query-builder/queryBuilderSlice';
import { LetsBuildAQuery } from '@/views/QueryBuilder/subcomponents';
import { ContentContainer } from '@/views/QueryBuilder/QueryBuilder.styles';

const GetStarted = () => {
  const getStarted = useAppSelector(selectGetStarted);
  const noOfTables = useSelector(getDatasourceTables).length;

  return (
    <ContentContainer>
      <div className={styles.startMessageContainer}>
        {noOfTables === 0 && <EmptyDatabaseMessage />}
        {noOfTables !== 0 && getStarted && <LetsBuildAQuery />}
      </div>
    </ContentContainer>
  );
};

export default GetStarted;
